<template>
    <div>
        <h1>View My {{ settings.appraisal }}</h1>
        <div class="shadow p-3 mb-5 bg-white rounded">
            <div v-if="ise(currentappraisal)">
                <p>No {{ settings.appraisal }} selected.</p>
                <p>Please <router-link to="/list">select</router-link> the {{ settings.appraisal }} first.</p>
            </div>
            <div v-if="! ise(currentappraisal)">
                <b-container class="bv-example-row">
                    <b-row>
                        <b-col>Start Date</b-col>
                        <b-col>{{ currentappraisal.startdate | formatDate }} </b-col>
                    </b-row>
                    <b-row>
                        <b-col>Review Date</b-col>
                        <b-col>{{ currentappraisal.reviewdate | formatDate }}</b-col>
                    </b-row>
                    <div v-if="hasobjectives"> 
                        <b-row v-for="objective in currentappraisal.objectives" v-bind:key="objective.id">
                            <b-col>{{ objective.description }}</b-col>
                            <b-col>{{ objective.evidence }}</b-col>
                        </b-row>
                    </div>
                    <b-row  v-if="!hasobjectives">
                        <b-col>
                            No entries.
                        </b-col>
                    </b-row >
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>

import moment from 'moment'
import { mapGetters } from 'vuex'

import { isEmpty } from 'lodash/core';    

export default {
    name: 'ViewAppraisal',
    filters: {
        formatDate: function (value) {
            if (!value) return ''
            return moment(value).format('DD/MM/YYYY')
        }
    },

    methods: {
        ise: function (obj)
        {
            return isEmpty(obj)
        }
    },

    computed: {
        ...mapGetters([
            'currentappraisal',
            'settings'
        ]),
        hasobjectives: function () {
            return this.currentappraisal.objectives.length ? true : false
        },
    },

}

</script>